export enum ElementType {
  EMPTY = '__empty__',
  ID_OVERAGE = '__overage__',
  ID_SHORTAGE = '__shortage__',
}
